/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderCallButtonPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The contact number
   */
  contactNumber: PropTypes.string.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * The width of the screen. Provided by @material-ui/core/withWidth
   */
  width: PropTypes.string.isRequired,
};

export default OrderCallButtonPropTypes;
